import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useTask } from '../../context/TaskContext';
import { ITask } from '../../interface/tasks';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { usePage } from '../../context/PageContext';
import { Radio, RadioGroup, Text } from '../Ant';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { useEscapeToGoBack } from '../../hooks/useEscapeToGoBack';
import { useDiscardDialog } from '../../hooks/useDiscardDialog';
import { isTaskFormChanged } from './isTaskFormChanged';
import CustomModal from '../informationPopup/customModal';
import { Slash } from '../icons';

const PriorityListing = () => {
  const { t } = useTranslation();
  const { goBack, goBackWithSelection } = useNavigationStack();
  const { task, updateTask, initialTask, clearInitialTask } = useTask();
  const { setTitle } = usePage();
  const { showDiscardDialog, promptDiscardIfChanged, handleDiscardConfirm, handleDiscardCancel } =
    useDiscardDialog();

  const handleSelect = (value: string) => {
    updateTask({
      ...task,
      priority: value,
    } as ITask);
    goBackWithSelection();
  };
  const handleBack = () => {
    goBack();
  };
  useEscapeToGoBack(handleBack);
  const handleClose = () => {
    promptDiscardIfChanged(isTaskFormChanged(task, initialTask, !!task?.id), () => {
      updateTask(null);
      clearInitialTask();
      goBack(undefined, 2);
    });
  };

  const priorityList = [
    { label: t('task:priorityLevel.high'), value: 'high' },
    { label: t('task:priorityLevel.low'), value: 'low' },
    { label: t('task:priorityLevel.normal'), value: 'normal' },
  ];
  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        handleBack={handleBack}
        handleClose={handleClose}
        showBackWithCross
        title={t('task:selectPriority')}
        showCross
      />,
    );
  }, []);
  return (
    <>
      <RadioGroup
        className="d-flex flex-col gap-10 overflow-y-auto scroll-page-gutter h-full w-full"
        value={task?.priority}
      >
        {priorityList.map((priority) => (
          <Radio
            data-testid={`worktime-priority-${priority?.label}`}
            key={priority.value}
            value={priority.value}
            onClick={() => {
              handleSelect(priority?.value);
            }}
          >
            <Text
              data-testid={`worktime-priority-${priority?.label}-label`}
              $fontsize="13px"
              $weight={500}
              $color="title"
              $lineheight="20px"
            >
              {priority.label}
            </Text>
          </Radio>
        ))}
      </RadioGroup>
      <CustomModal
        visible={showDiscardDialog}
        onConfirm={handleDiscardConfirm}
        icon={<Slash />}
        title={t('common:discardChangesText')}
        subdescription={t('common:anyChangeMadeWillBeLostAndCannotBeReverted')}
        confirmText={t('common:discard')}
        cancelText={t('common:cancel')}
        onClose={handleDiscardCancel}
      />
    </>
  );
};

export default PriorityListing;
